var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126.18614mm",
    height: "126.18614mm",
    viewBox: "0 0 126.18614 126.18614",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      strokeWidth: 0.587938
    },
    id: "rect1",
    width: 126.18614,
    height: 126.18614,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    },
    id: "g1",
    transform: "matrix(0.39801367,0,0,0.39801336,0.64463443,8.1662335)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 23.4131,141.502 c -0.1405,0 -0.2791,-0.008 -0.4153,-0.024 -0.7954,-0.092 -1.5637,-0.455 -2.1536,-1.086 L -0.675533,117.389 c -1.320557,-1.412 -1.246767,-3.626 0.164831,-4.947 1.411593,-1.321 3.626442,-1.247 4.947002,0.165 l 15.7445,16.83 C 22.031,99.8721 33.4203,71.6134 52.7584,48.9715 73.9569,24.1512 103.316,7.70927 135.555,2.60312 c 32.239,-5.10616 65.242,1.45854 93.073,18.51338 27.831,17.0548 48.663,43.4804 58.75,74.5237 0.597,1.8384 -0.409,3.813 -2.247,4.4098 -1.839,0.598 -3.813,-0.4083 -4.411,-2.2467 C 271.149,68.3452 251.38,43.2689 224.971,27.085 198.561,10.901 167.243,4.67151 136.65,9.51693 106.057,14.3624 78.1973,29.9647 58.0812,53.5176 39.7746,74.9519 28.9748,101.691 27.1799,129.672 l 16.8324,-15.746 c 1.4116,-1.321 3.6265,-1.247 4.947,0.164 1.3206,1.412 1.2468,3.627 -0.1648,4.947 l -22.8063,21.336 c -0.6396,0.694 -1.5565,1.129 -2.5751,1.129 z m 264.8189,-6.179 c 1.423,-1.308 3.637,-1.215 4.945,0.208 l 21.319,23.189 c 1.309,1.423 1.216,3.637 -0.207,4.946 -1.423,1.308 -3.638,1.215 -4.946,-0.208 L 293.82,146.573 c -1.852,29.563 -13.241,57.82 -32.578,80.46 -21.198,24.821 -50.557,41.263 -82.796,46.369 -32.239,5.106 -65.242,-1.459 -93.0734,-18.514 -27.8309,-17.054 -48.6632,-43.48 -58.7498,-74.523 -0.5973,-1.839 0.4088,-3.813 2.2472,-4.411 1.8384,-0.597 3.8129,0.409 4.4102,2.248 9.5716,29.458 29.3401,54.534 55.7499,70.718 26.4099,16.184 57.7279,22.413 88.3209,17.568 30.592,-4.845 58.452,-20.448 78.568,-44.001 18.354,-21.489 29.162,-48.31 30.915,-76.37 l -17.054,15.679 c -1.423,1.308 -3.637,1.215 -4.945,-0.208 -1.309,-1.423 -1.216,-3.637 0.207,-4.945 z",
    fill: "#56AE4D",
    stroke: "#56AE4D",
    strokeWidth: 10,
    id: "path1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotation);
export default __webpack_public_path__ + "static/media/rotation.413653e71bdf4ad689fec4f5baa314a9.svg";
export { ForwardRef as ReactComponent };